import React from "react";
import { Popover, Tag } from "antd";

const StationPopover = ({
  station,
  stationColor,
  isOpen,
  layoutType,
  activeLayoutType,
  children,
  onOpenChange,
  trigger = "click",
}) => {
  const shouldOpen = isOpen && layoutType === activeLayoutType;

  return (
    <Popover
      content={
        <div>
          <div
            style={{
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Tag
              color={stationColor.primary}
              style={{
                margin: 0,
                fontSize: "11px",
              }}
            >
              {station.category || "未分類"}
            </Tag>
            {station.name || station.device_id || "未命名基站"}
          </div>
          {station.device_id && (
            <div
              style={{
                marginTop: 4,
                fontSize: "12px",
                color: "#8c8c8c",
              }}
            >
              裝置 ID: {station.device_id}
            </div>
          )}
          {station.position_meters && (
            <div
              style={{
                marginTop: 8,
                fontSize: "12px",
                color: "#8c8c8c",
              }}
            >
              位置: (
              {(station.position_meters?.x || station.position_meters?.x === 0
                ? station.position_meters.x
                : 0
              ).toFixed(2)}
              m,{" "}
              {(station.position_meters?.y || station.position_meters?.y === 0
                ? station.position_meters.y
                : 0
              ).toFixed(2)}
              m)
            </div>
          )}
        </div>
      }
      trigger={trigger}
      open={shouldOpen}
      onOpenChange={onOpenChange}
    >
      {children}
    </Popover>
  );
};

export default StationPopover;
